<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

const store = useStore();
const { t } = useI18n();
const currentAccountId = useMapGetter('getCurrentAccountId');
const isSaving = ref(false);

const allowProductDiscountPerItem = computed(() =>
  store.getters['accounts/allowProductDiscountPerItem'](currentAccountId.value)
);

const updateAllowProductDiscount = async value => {
  isSaving.value = true;
  try {
    await store.dispatch('accounts/update', {
      allow_product_discount_per_item: value,
      options: { silent: true },
    });
    useAlert(t('PDV.SETTINGS.SAVE_SUCCESS'));
  } catch (error) {
    useAlert(t('PDV.SETTINGS.SAVE_ERROR'));
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <div class="flex-1 overflow-y-auto p-4 md:p-6 bg-n-background">
    <div class="max-w-3xl mx-auto space-y-6">
      <div>
        <h3 class="text-base font-semibold text-n-text">
          {{ $t('PDV.SETTINGS.SECTIONS.SALES.TITLE') }}
        </h3>
        <p class="text-sm text-n-text-subtle mt-1">
          {{ $t('PDV.SETTINGS.SECTIONS.SALES.DESCRIPTION') }}
        </p>
      </div>

      <div
        class="rounded-xl border border-n-weak bg-n-solid-1 divide-y divide-n-weak"
      >
        <div class="flex items-center justify-between gap-3 px-4 py-3">
          <div>
            <p class="text-sm font-medium text-n-text">
              {{ $t('PDV.SETTINGS.ALLOW_PRODUCT_DISCOUNT.TITLE') }}
            </p>
            <p class="text-xs text-n-text-subtle mt-0.5">
              {{ $t('PDV.SETTINGS.ALLOW_PRODUCT_DISCOUNT.DESCRIPTION') }}
            </p>
          </div>
          <ToggleSwitch
            :model-value="allowProductDiscountPerItem"
            :disabled="isSaving"
            @update:model-value="updateAllowProductDiscount"
          />
        </div>
      </div>
    </div>
  </div>
</template>
